export const reducer = <T>(state: T, update: Partial<T> | ((state: T) => T)) => {
  if (typeof update === 'function') {
    return update(state);
  }
  return { ...state, ...update };
};
